<template>
  <div class="hero">
    <section class="hero__content">
      <div class="hero__text">
        <p class="hero__subtitle">Manumech Engineering Services Ltd.</p>
        <hr />
        <h1 class="tagline">
          Manufacturing and Engineering services in West Midlands, UK.
        </h1>
        <hr />
        <div class="play__section">
          <p>Scroll down to explore our business.</p>
        </div>
      </div>
      <!-- video*****  -->
      <div class="hero__video">
        <video loop autoplay muted>
          <source src="@/videos/hero_video3.mp4" type="video/mp4" />
        </video>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Hero",
};
</script>

<style>
@media screen and (max-width: 640px) {
  .tagline {
    font-size: 30px;
  }
}

</style>